import { createAction } from 'utils/redux'

export const receiveEmbedConfiguration = payload => createAction({
  type: 'RECEIVE_EMBED_CONFIGURATION',
  payload
})

export const receiveEmbedConfigurationOverride = payload => createAction({
  type: 'RECEIVE_EMBED_CONFIGURATION_OVERRIDE',
  payload
})

export const receiveEmbedWelcomeMessage = payload => createAction({
  type: 'RECEIVE_EMBED_WELCOME_MESSAGE',
  payload
})

export const receiveEmbedAwayMessage = payload => createAction({
  type: 'RECIEVE_EMBED_AWAY_MESSAGE',
  payload
})

